import { Component, h } from '@stencil/core';

@Component({
  tag: 'presto-playlist-ui',
  styleUrl: 'presto-playlist-ui.scss',
  shadow: true,
})
export class PrestoPlayListUI {
  render() {
    return (
      <div class="playlist__base" part="base">
        <div class="playlist">
          <div class="playlist__preview">
            <slot name="preview" />
          </div>
          <div class="playlist__info">
            <div class="playlist__heading">
              <div class="playlist__heading-title">
                <slot name="title"></slot>
              </div>
              <div class="playlist__heading-count">
                <slot name="count"></slot>
              </div>
            </div>

            <div class="playlist__info--inner">
              <div class="playlist__list">
                <slot name="list" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
